import PolylineIcon from "@mui/icons-material/Polyline";
import SquareFootIcon from "@mui/icons-material/SquareFoot";
import { Fab } from "@mui/material";
import React from "react";
import styles from "./MeasureModeButton.module.scss";

export const MeasureModeButton = React.memo(
  (props: {
    measureLengthMode: boolean;
    measureAreaMode: boolean;
    onQuitMeasureClick: () => void;
  }) => (
    <Fab
      onClick={props.onQuitMeasureClick}
      className={styles.measureModeButton}
    >
      {props.measureLengthMode ? <PolylineIcon /> : <SquareFootIcon />}
    </Fab>
  )
);
